import { Switch, Route } from "react-router-dom";
import Workflows from "./Workflows";

function AIFunctionsMain() {
  return (
    <Switch>
      <Route path="/ai-functions">
        <Workflows />
      </Route>
    </Switch>
  );
}

export default AIFunctionsMain;
